import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import 'features/reports/components/reports-list/reports-list.scss';
import { DataTable, Icon } from '@ampol/design-system';
import { getReportTypes } from 'actions/storeActions';
import { gtmReportEvents } from '../../../../GTM';

/**
 * Reports list scheduling new report
 * @returns JSX Element
 */
const ReportsList = ({ createNewReportSchedule }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getReportTypes());
  }, []);

  const reportTypes = useSelector((state) => state.dataStore.reportTypes);
  const reportTypesLoading = useSelector((state) => state.dataStore.reportTypesLoading);
  const [sortAscending, setSortAscending] = useState(true);
  const [showHelpReportTypeId, setShowHelpReportTypeId] = useState(null);

  const getSortedReportTypes = () => {
    let sortedReportTypes;

    if (sortAscending) {
      sortedReportTypes = reportTypes.sort((a, b) => {
        return a.reportName === b.reportName ? 0 : a.reportName < b.reportName ? -1 : 1;
      });
    } else {
      sortedReportTypes = reportTypes.sort((a, b) => {
        return a.reportName === b.reportName ? 0 : a.reportName > b.reportName ? -1 : 1;
      });
    }

    return sortedReportTypes;
  };

  const onTableColumnSorted = (column, isAsc) => {
    setSortAscending(isAsc);
  };

  const onHelpClick = (reportTypeId) => {
    gtmReportEvents(reportTypeId, 'reportHelp');
    setShowHelpReportTypeId(showHelpReportTypeId === reportTypeId ? null : reportTypeId);
  };

  const onRunReportClick = (e, reportTypeId) => {
    e.preventDefault();
    gtmReportEvents(reportTypeId, 'reportSchedule');

    const reportType = reportTypes.find(x => x.reportTypeId === reportTypeId);
    createNewReportSchedule(reportTypeId, reportType.reportName, reportType.reportDescription);
  };

  return <div className="report-list-modal">
    <DataTable
      columns={[
        {
          header: 'Report Name',
          defaultSorted: 'asc',
          accessorFn: (x) => <>
            <div key={x.reportTypeId} style={{ width: '100%' }}>
              <div className="report-list-modal__row-header">
                <div className="report-list-modal__row-report-name">
                  {x.reportName}
                </div>
                <div className="report-list-modal__row-help-icon" onClick={() => {
                  onHelpClick(x.reportTypeId);
                }}>
                  <Icon url={'/icons/help-circle.svg'}/>
                </div>
              </div>
              <div
                className={showHelpReportTypeId === x.reportTypeId ? 'report-list-modal__row-body' : 'report-list-modal__row-body-hidden'}>
                <div className="report-list-modal__row-report-description">
                  {x.reportDescription}
                </div>
              </div>
            </div>
          </>,
        },
        {
          id: 'action',
          accessorFn: (x) => <a
            className="report-list-modal__link"
            href="features/reports/components/reports-list/reports-list#" key={x.reportTypeId}
            onClick={(e) => onRunReportClick(e, x.reportTypeId)}>
            <span className="report-list-modal__link-text">{showHelpReportTypeId === x.reportTypeId && 'Run Report '}</span><Icon url={'/icons/arrow-right.svg'}/>
          </a>,
          rtl: true,
        },
      ]}
      isLoading={reportTypesLoading}
      loadingRowCount={15}
      isSortable
      columnTemplate={'1fr 200px'}
      textOverflow={'normal'}
      onColumnSorted={onTableColumnSorted}
      rows={getSortedReportTypes().slice()}
      tableVariant="list"
      onRowClick={(x) => onHelpClick(x.reportTypeId)}
      rowClassFn={(x) => showHelpReportTypeId === x.reportTypeId ? 'report-list-modal__row-highlight' : ''}
    />
  </div>;
};

export default ReportsList;
